import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import NightingaleLink from './NightingaleLink';
import './link.scss';

export const LinkText = ({
    as,
    children,
    href,
    to,
    ...linkProps
}) => {

    const linkAs = as ? as : (to ? <RouterLink to={to}></RouterLink> : <a href={href}></a>);

    return (
        <NightingaleLink
            {...linkProps}
            as={linkAs}
        >
            {children}
        </NightingaleLink>
    );
};
